import React from 'react';
import DateTimePicker from 'react-datetime';
import { DatePickerWrapper } from './CustomDateTimePicker.styles';
import 'react-datetime/css/react-datetime.css';

const CustomDateTimePicker = (props) => {
  return (
    <DatePickerWrapper>
      <DateTimePicker {...props} />
    </DatePickerWrapper>
  );
};
export default CustomDateTimePicker;
